import {useUser} from '@local/redux/hooks/useUser';
import {UserHolder} from '@local/logics/global/userHolder';

export const UserConnector = () => {
  const {user} = useUser();
  UserHolder.user = user;
  return null;
};
